import { render, staticRenderFns } from "./WsRead.vue?vue&type=template&id=7b79a2b4&"
import script from "./WsRead.vue?vue&type=script&lang=js&"
export * from "./WsRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports